module.exports = __webpack_public_path__ + "img/headphones-over-ear.90b6bca5.png";